import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@mui/material/styles";
import "./i18n/i18n";
import "typeface-roboto";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import CAIHTheme from "./theme";

ReactDOM.render(
  <ThemeProvider theme={CAIHTheme}>
    <App />
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
